import React from "react";

const getAddedLogsForVerificationPreference = (
  logString,
  performedByEmail,
  updatedFields,
  blank
) => {
  const contactMethod = updatedFields.filter((val) => val.key.includes("contactMethod"));
  const contactName = updatedFields.filter((val) => val.key.includes("name"));
  const contactAvailabilityArray = updatedFields.filter((val) =>
    val.key.includes("contactAvailability")
  );
  const contactAvailabilityObj = getContactAvailabilityByDay(contactAvailabilityArray);
  if (contactMethod.length > 0 || contactName.length > 0 || contactAvailabilityArray.length > 0) {
    return (
      <p>
        {logString} {performedByEmail} added Contact <br />
        {contactName.map((fields) => {
          const { key, newValue } = fields;
          return (
            /* @ts-expect-error FIXME this wrong type */
            <info key={key}>
              {key} <b>{newValue || blank}</b>
              {/* @ts-expect-error FIXME this wrong type */}
            </info>
          );
        })}
        <br />
        {contactMethod.map((fields) => {
          const { key, newValue } = fields;
          return (
            /* @ts-expect-error FIXME this wrong type */
            <info key={key}>
              <b> {newValue || blank}</b>
              {/* @ts-expect-error FIXME this wrong type */}
            </info>
          );
        })}
        <br />
        {Object.keys(contactAvailabilityObj).map((field) => {
          return (
            /* @ts-expect-error FIXME this wrong type */
            <info key={field}>
              Availability For {field}{" "}
              <b>
                From {contactAvailabilityObj[field]?.start?.newValue || blank} to{" "}
                {contactAvailabilityObj[field]?.end?.newValue || blank}
              </b>
              {/* @ts-expect-error FIXME this wrong type */}
            </info>
          );
        })}
      </p>
    );
  } else {
    return (
      <p>
        {logString} {performedByEmail} added verification preference{" "}
        {updatedFields.map((fields) => {
          const { key, newValue } = fields;
          return (
            /* @ts-expect-error FIXME this wrong type */
            <info key={key}>
              {key?.includes("verificationAttempt") ? "Verification Attempt" : "Verification Type"}{" "}
              <b>{newValue}</b>
              {/* @ts-expect-error FIXME this wrong type */}
            </info>
          );
        })}
      </p>
    );
  }
};

const getUpdatedLogsForVerificationPreference = (
  logString,
  performedByEmail,
  updatedFields,
  blank
) => {
  const contactMethod = updatedFields.filter((val) => val.key.includes("contactMethod"));
  const contactName = updatedFields.filter((val) => val.key.includes("name"));
  const contactAvailabilityArray = updatedFields.filter((val) =>
    val.key.includes("contactAvailability")
  );
  const contactAvailabilityObj = getContactAvailabilityByDay(contactAvailabilityArray);
  if (contactMethod.length > 0 || contactName.length > 0 || contactAvailabilityArray.length > 0) {
    return (
      <p>
        {logString} {performedByEmail} updated {contactMethod ? "Contact" : "Value"}
        <br />{" "}
        {contactName.map((fields) => {
          const { key, previousValue, newValue } = fields;
          return (
            /* @ts-expect-error FIXME this wrong type */
            <info key={key}>
              from <i>{previousValue}</i> to <b>{newValue}</b>{" "}
              {/* @ts-expect-error FIXME this wrong type */}{" "}
            </info>
          );
        })}
        <br />
        {contactMethod.map((fields) => {
          const { key, previousValue, newValue } = fields;
          return (
            /* @ts-expect-error FIXME this wrong type */
            <info key={key}>
              from <i>{previousValue}</i> to <b>{newValue}</b>{" "}
              {/* @ts-expect-error FIXME this wrong type */}{" "}
            </info>
          );
        })}
        <br />
        {Object.keys(contactAvailabilityObj).map((field) => {
          return (
            /* @ts-expect-error FIXME this wrong type */
            <info key={field}>
              Availability For {field}{" "}
              <b>
                From {contactAvailabilityObj[field]?.start?.previousValue || blank} to{" "}
                {contactAvailabilityObj[field]?.end?.previousValue || blank}
              </b>
              To new Time{" "}
              <b>
                From {contactAvailabilityObj[field]?.start?.newValue || blank} to{" "}
                {contactAvailabilityObj[field]?.end?.newValue || blank}
              </b>
              {/* @ts-expect-error FIXME this wrong type */}{" "}
            </info>
          );
        })}
      </p>
    );
  } else {
    return (
      <p>
        {logString} {performedByEmail} updated verification preference{" "}
        {updatedFields.map((fields) => {
          const { key, previousValue, newValue } = fields;
          return (
            /* @ts-expect-error FIXME this wrong type */
            <info key={key}>
              {key?.includes("verificationAttempt") ? "Verification Attempt" : "Verification Type"}{" "}
              from <i>{previousValue}</i> to <b>{newValue}</b>{" "}
              {/* @ts-expect-error FIXME this wrong type */}{" "}
            </info>
          );
        })}
      </p>
    );
  }
};

const getRemovedLogsForVerificationPreference = (logString, performedByEmail, updatedFields) => {
  return (
    <p>
      {logString} {performedByEmail} removed Contact with name{" "}
      <b>
        {updatedFields.map((fields) => {
          const { key, newValue } = fields;
          return (
            /* @ts-expect-error FIXME this wrong type */
            <info key={key}>
              {" "}
              <b>{newValue}</b>
              {/* @ts-expect-error FIXME this wrong type */}
            </info>
          );
        })}
      </b>
    </p>
  );
};

const getContactAvailabilityByDay = (contactAvailability) => {
  return contactAvailability.reduce((acc, cur) => {
    if (cur.key.includes("timeRange.start")) {
      const availabilityDay = getDay(cur.key);
      if (acc[availabilityDay]) {
        acc[availabilityDay]["start"] = {
          newValue: cur.newValue,
          previousValue: cur.previousValue,
        };
      } else {
        acc[availabilityDay] = {
          start: {
            newValue: cur.newValue,
            previousValue: cur.previousValue,
          },
        };
      }
    } else if (cur.key.includes("timeRange.end")) {
      const availabilityDay = getDay(cur.key);
      if (acc[availabilityDay]) {
        acc[availabilityDay]["end"] = {
          newValue: cur.newValue,
          previousValue: cur.previousValue,
        };
      } else {
        acc[availabilityDay] = {
          end: {
            newValue: cur.newValue,
            previousValue: cur.previousValue,
          },
        };
      }
    }
    return acc;
  }, {});
};

const getDay = (day) => {
  const a = day.split(".");
  return a[1];
};

export {
  getAddedLogsForVerificationPreference,
  getRemovedLogsForVerificationPreference,
  getUpdatedLogsForVerificationPreference,
};
